export default __webpack_public_path__ + "static/media/email-icon.3b8a6074.svg";